import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /** Disables the filter's interactive controls. */
  disabled: booleanAttribute(),
  /**
   * Clear signal from the SP Filter wrapper's v-model. A falsy value resets every
   * sub-selection (chip clear / deactivate); non-empty echoes are ignored —
   * restoring values flows through `setFilterValues`.
   */
  modelValue: {
    type: [Object, String],
    default: undefined,
  },
  /**
   * The doctor-finder embed uuid → selects the shared omnisearch store instance
   * that backs the name combobox.
   */
  uuid: {
    type: String,
    default: undefined,
  },
  /** @type {Boolean|String} */
  open: booleanAttribute(),
  /** Chip label shown by the filter-bar activator. */
  label: {
    type: String,
    default: "Provider",
  },
  /** Icon shown on the filter-bar activator chip. */
  prependIcon: {
    type: String,
    default: "doctor-filled",
  },
  /**
   * The new-patient radio options, as `[{ value, label }]`. An empty list renders no radio group.
   * Arrives as a JSON string from the server-rendered mount.
   *
   * @type {Array|String}
   */
  newPatientOptions: {
    type: [Array, String],
    default: undefined,
  },
  /**
   * The provider types offered, as `[{ title, value }]`. Arrives as a JSON string from the server-rendered mount.
   *
   * @type {Array|String}
   */
  providerTypeOptions: {
    type: [Array, String],
    default: () => [],
  },
  /**
   * Affiliation sub-control config (conditional per publishing domain):
   * `{ enabled, mode: 'single' | 'multi', include_in_provider_chip, options: [{title, value}], single: {id, name} }`.
   */
  affiliation: {
    type: [Object, String],
    default: () => ({ enabled: false }),
  },
});
